export default __webpack_public_path__ + "static/fonts/DomaineSansDisplay-Regular.18d9796.woff2";